import { useState } from 'react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';
import { WifiOff, X } from 'lucide-react';

export function OfflineBanner() {
  const isOnline = useOnlineStatus();
  const [dismissed, setDismissed] = useState(false);

  if (isOnline || dismissed) return null;

  return (
    <div data-testid="offline-banner" className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-amber-950 px-4 py-2 flex items-center justify-center gap-2 text-sm font-['Manrope'] font-medium shadow-lg">
      <WifiOff className="w-4 h-4 flex-shrink-0" />
      <span>You're offline — some features may not work</span>
      <button onClick={() => setDismissed(true)} className="ml-2 p-0.5 rounded hover:bg-amber-600/20"><X className="w-3.5 h-3.5" /></button>
    </div>
  );
}
